<template>
  <div class="aktuelles">
    <v-container grid-list-sm>
      <v-layout row wrap>
        <v-flex md4 class="sum-fixed__wrapper">
          <template v-if="aktuelles">
            <div v-for="post in aktuelles_chronologically" :id="'sum_' + post.id" :key="post.id"
              :class="getActiveClass(post.id)">
              <div class="sum-type-section">{{ translate['Aktuelles'][lang] }}</div>
              <router-link v-if="lang === 'de'" class="lnk_nostyle" v-html="post.titel_de"
                :to="{ name: 'NewsId', params: { pid: post.id } }"></router-link>
              <router-link v-else class="lnk_nostyle" v-html="post.titel_en"
                :to="{ name: 'NewsId', params: { pid: post.id } }"></router-link>
            </div>
          </template>
          <v-progress-circular indeterminate color="grey" v-else></v-progress-circular>
        </v-flex>
        <template v-if="currentPost">
          <v-flex md8 class="max-width--960 flex-grow-1 flex-shrink-0">
            <div class="col-inner col-highlight">
              <h1 id="g-main-content-title" v-html="title"></h1>
              <div class="ffs display_date" v-html="display_date"></div>
              <div class="ffs" v-html="content"></div>
            </div>
          </v-flex>
        </template>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  firstSum: 0,
  name: 'News',
  data () {
    return {
      msg: 'News',
      cssClass: this.$options.name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase(),
      loading: true,
      currentPost: null
    }
  },
  created () {
    if (this.aktuelles.length === 0) {
      this.getWpAktuelles()
    }
  },
  mounted () {
    if (this.aktuelles.length > 0) {
      this.loading = false
      if (this.$route.params.pid) {
        this.setCurrentPost(Number(this.$route.params.pid))
      } else {
        this.setCurrentPost()
      }
    }
  },
  watch: {
    aktuelles: function () {
      if (this.aktuelles.length > 0 && this.$route.params.pid) {
        this.setCurrentPost(Number(this.$route.params.pid))
      } else if (this.aktuelles.length > 0) {
        this.setCurrentPost()
      }
    },
    '$route' (to, from) {
      this.setCurrentPost(to.params.pid)
    }
  },
  methods: {
    ...mapActions(['getWpAktuelles']),
    setCurrentPost (id, event) {
      if (event) {
        event.preventDefault()
      }
      if (id) {
        this.aktuelles.forEach(post => {
          if (post.id === id) {
            this.currentPost = post
            if (Number(this.$route.params.pid) !== id) {
              this.$router.push({ name: 'News', params: { pid: id } })
            }
          }
        })
      } else if (this.aktuelles.length > 0) {
        this.currentPost = this.aktuelles_chronologically[0]
      }
      let alle = document.getElementsByClassName('sum')
      for (var i = 0; i < alle.length; i++) {
        alle[i].classList.remove('sum-active')
      }
      let callerElement = document.getElementById('sum_' + id)
      if (callerElement) {
        callerElement.classList.add('sum-active')
      }
      let el = document.getElementById('g-main-content-title')
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
        }, 100)
      }
    },
    getActiveClass (id) {
      if (this.$route.params.pid) {
        if (Number(this.$route.params.pid) === id) {
          return 'col-inner col-highlight sum sum-active'
        } else {
          return 'col-inner col-highlight sum'
        }
      } else {
        if (this.$options.firstSum === 0) {
          this.$options.firstSum = this.$options.firstSum + 1
          return 'col-inner col-highlight sum sum-active'
        } else {
          return 'col-inner col-highlight sum'
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'aktuelles',
      'firstpost',
      'translate',
      'lang'
    ]),
    aktuelles_chronologically () {
      const aktuelles = this.aktuelles
      if (aktuelles && aktuelles.length) {
        return [...aktuelles].sort((a, b) => {
          const aTime = (new Date(a.date).getTime())
          const bTime = (new Date(b.date).getTime())
          return aTime < bTime ? 1 : aTime > bTime ? -1 : 0
        })
      }
    },
    title () {
      let result = ''
      if (this.currentPost) {
        if (this.lang === 'de') {
          result = this.currentPost.titel_de
        } else {
          result = this.currentPost.titel_en
        }
      }
      return result
    },
    content () {
      let result = ''
      if (this.currentPost) {
        if (this.lang === 'de') {
          result = this.currentPost.deutsch
        } else {
          result = this.currentPost.english
        }
      }
      return result
    },
    display_date () {
      let result = ''
      if (this.currentPost) {
        let date = new Date(this.currentPost.display_date)
        result = date.toLocaleDateString(this.lang)
      }
      return result
    }
  }
}
</script>
<style lang="scss" scoped>
.lnk_nostyle {
  text-decoration: none;
}

.display_date {
  text-align: right;
  margin-top: -1.5rem;
  margin-bottom: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/News.vue